<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import ImportTemplate from "@/views/components/common/form/commonImportTemplate.vue";
let customerId = window.localStorage.getItem("customerId");
import config from "@/../config";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "commondescrMain",
        key: "id",
        url: {
          del: "/admin/system/common",
          list: "/admin/system/common/mainList",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/commondescr/add",
        },
        {
          label: "导入分类",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/commondescr/download",
          type: "info",
        },
        // {
        //   label: "导出字典",
        //   icon: "md-download",
        //   type: "info",
        //   onClick: this.exportData.bind(this, "服务字典列表", 6),
        //   auth: "system/commondescr/exportData",
        // },
      ],
      menus: [],
      filters: [
        {
          label: "常用内容",
          name: "descr",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "类型",
          name: "workType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 2,
              name: "维修内容",
            },
            {
              value: 3,
              name: "故障原因",
            },
          ],
        },
      ],
      tableCols: [
        {
          // type: "selection",
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "类型",
          key: "workType",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.workType == 2
                ? "维修内容"
                : row.workType == 3
                ? "故障原因"
                : "";
            return <span>{text}</span>;
          },
        },

        {
          title: "常用内容",
          minWidth: 180,
          align: "left",
          key: "descr",
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/commondescr/edit",
            del: "system/commondescr/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/common/template/download`;
    },
    toAdd() {
      $utils.url.push({
        name: "commondescr_add_main",
        query: { action: "add" },
      });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commondescr_add_main",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>
<style scoped></style>
